export default {
  "content": "<title>arrow double left</title><path d=\"M12 16.473l4.945-4.973L12 6.527 13.522 5 20 11.5 13.522 18 12 16.473zM4 16.473L8.945 11.5 4 6.527 5.522 5 12 11.5 5.522 18 4 16.473z\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "3 3 18 18",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};